import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../ui-inlined-svg/ui-inlined-svg';
import iconStyle from './ui-more-options-icon.css?inline';

const CName = 'ui-more-options-icon';

@customElement(CName)
export class UiMoreOptionsIcon extends LitElement {
  static readonly styles = unsafeCSS(iconStyle);

  render() {
    // Use vite to transform static URL
    const assetUrl = new URL('/assets/ui-core/icons/more-options-icon.svg', import.meta.url).href;
    return html`<ui-inlined-svg .defer=${true} .src=${assetUrl}></ui-inlined-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UiMoreOptionsIcon;
  }
}
